export const appColor = {
  // タスクページ
  TaskRow: {
    default: {
      topTitle: "#FBFBFB",
      group: "#FBFBFB",
      project: "#FBFBFB",
      primaryItem: "#FAFAFA",
      addition: "#FFFFFF",
      none: "#FFFFFF",
      inProgress: "#FFFFFF",
      done: "#D0D0D0",
      closed: "#AEAEAE",
      expiredDeadline: "#fed1d2",
      weekDeadline: "#d3dcf2",
      nearDeadline: "#d2f0da",
      nowDeadline: "#fcefc9",
      hasNotification: "#fec73e",
      noNotification: "#dde1e5",
    },
    hover: {
      topTitle: "#EBEBEB",
      group: "#EBEBEB",
      project: "#EBEBEB",
      primaryItem: "#EAEAEA",
      addition: "#FFFFFF",
      none: "#EFEFEF",
      inProgress: "#EFEFEF",
      done: "#A7A7A7",
      closed: "#A7A7A7",
      expiredDeadline: "#FDC0CB",
      nearDeadline: "#FFF6B0",
      nowDeadline: "#FDC5B4",
    },
  },
  SignUp: {
    title: "#081735",
    background: "#f8fafb",
    text: "#445470",
    lightGray: "#dee3ef",
    whiteBlue: "#f8fafb",
    lightBlue: "#f5f9ff",
  },
  // グラフ用
  Analytics: {
    blue: "#1E88E5",
    red: "#FF7474",
    green: "#00D4BB",
  },
  // その他。共通
  App: {
    primary: "#3967C4",
    accent: "#DE3E44",
    gray: "#BDBDBD",
    white: "#FFFFFF",
    green: "#34A853",
  },
  Accent: {
    primary: "#AD002D",
    secondary: "#181B39",
    orange: "#EA930A",
    lightOrange: "#FFC700",
    purple: "#624498",
    lightPurple: "#9C4AEF",
    blue: "#3391FF",
    green: "#26C953",
    yellow: "#F4BD25",
    red: "#FC484A",
    pink: "#EB466E",
  },
  Text: {
    primary: "#203744", // 主にメインテキストなどに使用
    secondary: "#727171", // 非アクティブ要素や注釈のテキストなどに使用
    black: "#454746",
    white: "#FFFFFF",
    dark: "#313C4F",
    darkGray: "#6D6E6F",
    gray: "#8C949B",
    ghost: "#c6cacd",
    brand: "#464BA8",
    periodic: "#EF8D4A",
    purpleGray: "#858e9f",
    error: "#b20030",
    navBar: "#EEF2F9",
    context: "#353A44",
  },
  Border: {
    primary: "#F6F7F8", // Divider/Border/Strokeが主にアクティブなときに使用
    secondary: "#F7F7F7", // Divider/Border/Strokeが主に非アクティブなときに使用
    gray: "#DADCE0",
    third: "#F1F1F1",
    headerBell: "#D3DBE2",
    purpleGray: "#dcb0ff",
    darkGray: "#A9A9A9",
    brand: "#464BA8",
    periodic: "#EF8D4A",
    copilotTable: "#DEE3DF",
    report: "#D5DBE1",
    lightGray: "#dee3ef",
  },
  Background: {
    primary: "#FBFBFB", // メインバックグラウンドで使用
    secondary: "#F7F7F7", // サブコンテンツのバックグラウンドで使用
    selected: "#D0D0D0", // リストアイテムなどが選択状態のときに使用
    tertiary: "#F6F7F8", // セレクト状態などで使用月白(げっぱく)
    auth: "#FBFBFB", // Authの背景色
    navBar: "#EEF2F9",
    footer: "#EEF2F9",
    white: "#FFFFFF",
    brand: "#464BA8",
    brandGray: "#D8DDE6",
    blur: "#000221",
    purpleGray: "#fcf9ff",
    pink: "#FFEBE9",
    dialogHeader: "#F6F8FA", // 通知設定ダイアログヘッダー等
    brandActive: "#6469C6",
    active: "#EBF4FF",
    alert: "#CF222E",
    lightGray: "#F8F8F8",
    // アクセント
    blue: "#DEEDFF",
    green: "#EBFFF0",
    yellow: "#F0E4C3",
    red: "#F2CBCB",
    gray: "#DADBDD",
  },
  Form: {
    primary: "#FFFFFF", // 活性状態のときに使用
    secondary: "#FCFCFE", // 非活性状態のときに使用
  },
  Button: {
    primary: {
      color: "#2B2A27",
      text: "#FFFFFF",
    }, // メインボタン
    negative: {
      color: "#F4F3F8",
      text: "#B4B4BE",
    }, //主にボタンが非アクティブ状態で使用
    accent: {
      red: "#FF7663",
      gray: "#7F7F89",
      facebook: "#1877F2",
    },
    social: {
      facebook: "#5E6E9F",
    },
    methodExplanation: {
      color: "#feb421",
      text: "#FFFFFF",
      hover: "#e0a71d",
    },
  },
  Report: {
    Status: {
      wait: "#6C7688",
      done: "#1A7F37",
    },
  },
  // 組織ページ
  StaffRow: {
    default: {
      none: "#FFFFFF",
    },
    hover: {
      none: "#EFEFEF",
    },
  },
} as const;
